import { getFirstCapitalizedLetter } from './string';
export function getConnectorLetter(connector) {
    var name = connector.name;
    if (name.startsWith('Banco')) {
        return getFirstCapitalizedLetter(name.substring(6, name.length));
    }
    return connector.name[0].toUpperCase();
}
